import React from 'react';
import { formatByHint } from './criteriaBarUtils';

export default function ItemValueChangeRow({ valueChangeDisplay, className = '' }) {
  if (!valueChangeDisplay) return null;
  const currency = valueChangeDisplay.currency || 'USD';
  const hint = valueChangeDisplay.format_hint || 'decimal_2';
  const before = formatByHint(valueChangeDisplay.value_before, hint, currency);
  const after = formatByHint(valueChangeDisplay.value_after, hint, currency);

  return (
    <div className={`text-xs text-white/70 tabular-nums ${className}`}>
      {before} <span className="text-white/40">→</span> <span className="text-white/90 font-semibold">{after}</span>
    </div>
  );
}

